import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import Spinner from "react-activity/dist/Spinner";
import tanuragalogo from "../assets/images/tanuraga-logo.png";
import { apiUrl } from '../config/Config';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || sessionStorage.getItem('passwordResetEmail') || "";
  const [password, setpassword] = useState("");
  const [repassword, setrepassword] = useState("");
  const [showloding, setshowloding] = useState(false);

  const handleSubmit = async(e) => {
    e.preventDefault();

    if (!email) {
      navigate('/forgot-password', { replace: true });
      return;
    }

    if (!password || !repassword) {
      Swal.fire({
        title: '',
        text: 'Password and confirm password are required',
        icon: 'error',
        width: '350px',
        confirmButtonText: 'Ok',
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: {
          popup: "small-icon-alert",
        },
      });
      return;
    }

    if (password !== repassword) {
      Swal.fire({
        title: '',
        text: 'Password and confirm password do not match',
        icon: 'error',
        width: '350px',
        confirmButtonText: 'Ok',
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: {
          popup: "small-icon-alert",
        },
      });
      return;
    }

    setshowloding(true);
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      }
    };

    await axios.post(apiUrl + 'customerresetpassword', { email, password }, headers).then((res) => {
      if(res.data.status === 'success') {
        sessionStorage.removeItem('passwordResetEmail');
        Swal.fire({
          title: '',
          text: res.data.message,
          icon: 'success',
          width: '350px',
          confirmButtonText: 'Ok',
          confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
            popup: "small-icon-alert",
          },
        });
        navigate('/login', { replace: true });
      } else {
        Swal.fire({
          title: '',
          text: res.data.message,
          icon: 'error',
          width: '350px',
          confirmButtonText: 'Ok',
          confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
            popup: "small-icon-alert",
          },
        });
      }
    }).catch((err) => {
      alert(err.message);
    });
    setshowloding(false);
  };

  return (
    <div className="register-page-container">
      <div className="register-page-card">
        <div className="register-page-header">
          <h2 className="register-page-logo">
            <img src={tanuragalogo} className='loginpagelogo' alt="Tanuraga Logo" />
          </h2>
          <p className="register-page-tagline">Reset Password</p>
        </div>

        <form className="login-page-form" onSubmit={handleSubmit}>
          <div className="register-page-form-group">
            <label htmlFor="password" className="register-page-label">New Password</label>
            <input
              type="password"
              id="password"
              className="register-page-input"
              placeholder="Enter new password"
              value={password}
              onChange={(t) => setpassword(t.target.value)}
              required
            />
          </div>

          <div className="register-page-form-group">
            <label htmlFor="repassword" className="register-page-label">Confirm Password</label>
            <input
              type="password"
              id="repassword"
              className="register-page-input"
              placeholder="Confirm new password"
              value={repassword}
              onChange={(t) => setrepassword(t.target.value)}
              required
            />
          </div>

          <button type="submit" className="register-page-button">
            {
              showloding ?
              <Spinner color='#fff' size={15} className='spinnerCenter' /> :
              "Reset Password"
            }
          </button>
        </form>

        <p className="register-page-separator">Or</p>
        <p className="register-page-footer">
          Return to <Link to={'/login'} className="register-page-link">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
